<template>
  <div class="schedules">
    <!-- Title and Header -->
    <div class="schedules__top">
      <div class="schedules__top__title">
        <h2 class="medium-title">
          Schedules
        </h2>
      </div>
      <div class="schedules__top__buttons">
        <button v-if="user.groups.includes('grazilla')" class="btn-large secondary" @click="toManage"> Manage Content </button>
        <button class="btn-large secondary" @click="toUpload"> Upload Content </button>
      </div>
    </div>
    <div class="schedules__header">
      <div class="schedules__header__left">
        <div class="schedules__header__left__search">
          <i class="adx-ic_search"></i>
          <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
        </div>
        <div class="schedules__header__left__status">
          <adx-dropdown-list 
            :labelButton="selectedStatus.label?selectedStatus.label:'All Status'" 
            :list="statusList"
            @selected="selectStatus"/>
        </div>
        <div class="schedules__header__left__status">
          <adx-dropdown-list 
            :labelButton="selectedType.label?selectedType.label:'All Type'" 
            :list="typeList"
            @selected="selectType" />
        </div>
        <div v-if="selectedSchedules.length > 0" class="schedules__header__left__delete">
          <button @click="deleteSchedules" class="btn-regular secondary"
          :class="isLoadingDelete ? 'disabled' : ''">
            <span> Delete </span> <adx-loading-spin v-if="isLoadingDelete" />
          </button>
        </div>
      </div>
      <div class="schedules__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <!-- Schedules -->
    <div class="schedules__content">
      <div>
        <table>
          <thead class="none">
            <tr>
              <td class="checklist">
                <div class="schedules__content__selection">
                  <span :class="['selection-checkbox', selectAll ? 'checked' : '']" @click.stop="toggleCheckAllItem()"><i class="icon-check"></i></span>
                </div>
              </td>
              <td class="header subhead">STATUS</td>
              <td class="header subhead">FILE NAME</td>
              <td class="header subhead">LOCATION</td>
              <td class="header subhead">PLACEMENTS</td>
              <td class="header subhead">DURATION</td>
              <td class="header subhead">TYPE</td>
              <td class="header subhead">PERIOD</td>
              <td></td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" class="content">
              <td class="checklist">
                <div class="schedules__content__selection">
                  <span :class="['selection-checkbox', 
                  selectedSchedules.includes(item.id) ? 'checked' : '',
                  checkPermission(item.type) ? '' : 'disabled']"
                  @click="checkPermission(item.type) ? toggleCheck(item.id) : ''"><i class="icon-check"></i></span>
                </div>
              </td>
              <td class="status subhead">
                <span :class="[item.get_status, 'strong']"> {{item.get_status}} </span>
              </td>
              <td class="file subhead">{{ item.content_name }}</td>
              <td class="location subhead">{{ item.device_location_name }}</td>
              <td class="placement subhead">{{ item.device_placement }}</td>
              <td class="duration subhead">{{ item.duration }} Sec</td>
              <td>{{ item.type }}</td>
              <td class="date subhead">
                {{transformDate(item.start)}} - {{transformDate(item.end)}}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination -->
        <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/></div>
        <!-- Loading State-->
        <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
        <!-- Empty State -->
        <div class="emptyState"><adx-empty-selection v-if="isEmpty && !isLoading" /></div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import SideBar from '@/components/SideBar/Desktop'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Modal from '@/components/Modal'
import types from '@/lib/types'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import LoadingSpin from '@/components/Loading/Secondary'
import Pagination from '@/components/Pagination'

// Api
import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-host-schedules',
  components: {
    'adx-sidebar': SideBar,
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-modal': Modal,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-loading-spin': LoadingSpin,
    'adx-pagination': Pagination,
  },
  data() {
    return {
      selectAll: false,
      isOpen: false,
      sort: [
        {
          'id': 0,
          'label': 'Last Added',
          'value': '-created'
        },
        {
          'id': 1,
          'label': 'First Added',
          'value': 'created'
        },
      ],
      selectedStatus: {
        id: 0,
        label: 'All Status',
        value: 'active,upcoming'
      },
      selectedSortValue: '-created',
      selectedSchedules: [],
      searchBoxValue: '',
      selectedRow: null,
      isInit: true,
      isLoading: false,
      isLoadingDelete: false,
      isEmpty: false,
      details: [],
      selectedPage: 1,
      maxPage: 0,
      items: [],
      statusList: [
        {
          id: 0,
          label: 'All Status',
          value: ''
        },
        {
          id: 1,
          label: 'Active',
          value: 'active'
        },
        {
          id: 2,
          label: 'Upcoming',
          value: 'upcoming'
        },
        {
          id: 3,
          label: 'Pending',
          value: 'pending'
        },
        {
          id: 4,
          label: 'Expired',
          value: 'expired'
        },
        {
          id: 5,
          label: 'Disapproved',
          value: 'rejected'
        },
      ],
      selectedType: {
        id: 0,
        label: 'All Type',
        value: ''
      },
      typeList: [
        {
          id: 0,
          label: 'All type',
          value: ''
        },
        {
          id: 1,
          label: 'Self Owned',
          value: 'selfowned'
        },
        {
          id: 2,
          label: 'Sponsored',
          value: 'sponsored'
        },
        {
          id: 3,
          label: 'Commercial',
          value: 'commercial'
        },
      ]
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        ordering: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined,
        status: this.selectedStatus.value || undefined,
        type: this.selectedType.value || undefined,
      }
      return params
    },
    ...mapGetters({
      user: 'account',
    })
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1
        this.initalLoad()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        this.initalLoad()
      }
    },
    selectedStatus: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedStatus = newValue
        this.initalLoad()
      }
    },
    selectedType: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedType = newValue
        this.initalLoad()
      }
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    
  },
  mounted() {
    if (this.$route.query.page) {
      this.selectedPage = this.$route.query.page
    }
    this.initalLoad()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    checkPermission(type){
      let isAdmin = this.user.groups.includes('grazilla')
      if (type == 'Self Owned' || isAdmin) return true
      return false
    },
    toUpload(){
      this.$router.push({name:'hostschedulesupload'})
    },
    toManage(){
      this.$router.push({name:'hostschedulesmanage'})
    },
    transformDate(value){
      return moment.utc(value).local().format('DD MMM YYYY')
    },
    initalLoad(isInit = null) {
      (async () => {
        this.isLoading = true
        this.isEmpty = false
        let params = {
          page: this.selectedPage,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.dashboardHostSchedules, { needToken: true, params })
        if (!data.count) {
          this.isEmpty = true
        } 
        this.items = data.results
        this.maxPage = data.max_page
        
        this.$data.isLoading = false
      })();
    },
    deleteSchedules(){
      (async () => {
        this.isLoadingDelete = true
        let data = {
          list_id: this.selectedSchedules
        }
        const response = await api.patch(apiV2.dashboardHostSchedulesDelete, data, { needToken: true })
        if(response.status == 200) {
          this.items = this.items.filter(value => {
            if(!this.selectedSchedules.includes(value.id)) return value
          })
          this.selectedSchedules = []
        }
        this.isLoadingDelete = false
      })();
    },
    selectPage(item) {
      this.selectedPage = item
      this.initalLoad()
    },
    dateFormat(date) {
      return moment.utc(date).local().format('DD MMM YYYY')
    },
    selectStatus(item){
      this.selectedStatus = item
    },
    selectType(item){
      this.selectedType = item
    },
    toggleCheck(id) {
      if(this.selectedSchedules.includes(id)){
        let index = this.selectedSchedules.indexOf(id);
        if (index > -1) {
          this.selectedSchedules.splice(index, 1);
        }
      } else {
        this.selectedSchedules.push(id)
      }
      let incompleteSchedules = this.items.filter((schedule) => {
        return schedule.type !== 'Self Owned'
      })
      if ((this.items.length - incompleteSchedules.length) == this.selectedSchedules.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    toggleCheckAllItem() {
      if (this.selectAll) {
        this.unselectAllItem()
      } else {
        this.selectAllItem()
      }
    },
    selectAllItem() {
      this.selectAll = true
      let isAdmin = this.user.groups.includes('grazilla')
      this.selectedSchedules = []
      this.items.map(value => {
        if (isAdmin || value.type == 'Self Owned') {
          this.selectedSchedules.push(value.id)
        }
      })
    },
    unselectAllItem() {
      this.selectedSchedules = []
      this.selectAll = false
    },
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
